/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance, { axiosInstance9000 } from '../../api/axiosInstance';

export const createClaimComment = createAsyncThunk(
  'claimComment/create',
  async ({ post_id, body, files }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('post_id', post_id);
      formData.append('body', body);
      files?.forEach((file, index) => {
        formData.append(`file[${index}]`, file);
      });

      const response = await axiosInstance9000.post(
        '/api/branch/message/reply',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const claimCommentSlice = createSlice({
  name: 'claimComment',
  initialState: {
    loading: false,
    success: false,
    message: '',
    error: null,
  },
  reducers: {
    resetCommentState: (state) => {
      state.loading = false;
      state.success = false;
      state.message = '';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createClaimComment.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.message = '';
        state.error = null;
      })
      .addCase(createClaimComment.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(createClaimComment.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || 'Failed to create comment';
      });
  },
});

export const { resetCommentState } = claimCommentSlice.actions;
export default claimCommentSlice.reducer;
